import styled from '@emotion/styled'
import { Button } from 'shop/components'
import { useCartMatch, useConsumerCart } from 'shop/hooks'
import { formatMoney, sanitizeNumber } from 'shop/utils/common'
import { StyledStrikethroughPrice } from '../ProductInfo/commonStyles'
import DiscountBasketValue from '../ShopCart/DiscountBasketValue/DiscountBasketValue'

interface Props {
  onClick: () => void
}

const StickyCartTotalMobileFooter = ({ onClick }: Props) => {
  const { cartLoading, cart } = useConsumerCart()
  const { isCartMatch } = useCartMatch()
  const { summary } = cart || {}
  const { deliveryPricingBands, subtotal } = summary || {}
  const { discounted, base } = subtotal || {}
  const cartSubtotal = discounted || base
  const isDiscounted = !!(discounted && discounted !== base)
  const total = sanitizeNumber(cartSubtotal)
  const totalOrderItemsQuantity =
    cart?.orderItems.reduce((acc, item) => item.quantity + acc, 0) || 0
  const shouldShowDiscountBasketVal =
    isCartMatch && !!parseFloat(base || '0') && !!deliveryPricingBands?.length

  return (
    <StickyMobileFooter data-testid='cart-total-sticky-mobile-footer'>
      {shouldShowDiscountBasketVal && (
        <DiscountBasketValue
          cartLoading={cartLoading}
          subtotal={base}
          deliveryPricingBands={deliveryPricingBands}
        />
      )}
      <Button
        type='button'
        onClick={onClick}
        isLoading={cartLoading}
        CustomTextWrapper={CustomTextWrapper}
        contentWidth='100%'
        borderRadius={'6px'}
      >
        <span>{totalOrderItemsQuantity && totalOrderItemsQuantity}</span>
        <span>View cart </span>
        <span>
          {isDiscounted ? (
            <Price>
              {formatMoney(discounted ?? '0')}
              <StyledStrikethroughPrice>
                {formatMoney(base ?? '0')}
              </StyledStrikethroughPrice>
            </Price>
          ) : (
            formatMoney(total)
          )}
        </span>
      </Button>
    </StickyMobileFooter>
  )
}

const Price = styled.div({
  display: 'flex',
  flexDirection: 'column',
  fontSize: '14px'
})

const CustomTextWrapper = styled.div<{ isLoading: boolean }>(
  ({ isLoading }) => ({
    visibility: isLoading ? 'hidden' : 'visible',
    '> svg': { marginRight: '8px' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  })
)

const StickyMobileFooter = styled.div(({ theme }) => ({
  zIndex: 20, // same as NavBar
  position: 'fixed',
  bottom: '0',
  left: '0',
  right: '0',
  display: 'flex',
  flexDirection: 'column',
  padding: '12px',
  backgroundColor: 'white',
  boxShadow: '0 -1px 8px 8px rgba(0, 0, 0, 0.05)',

  [theme.mediaQueries.viewport10]: {
    display: 'none'
  }
}))

export default StickyCartTotalMobileFooter
